"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportListItemProps = void 0;
const canDto_1 = require("../dtos/canDto");
class ReportListItemProps {
    constructor(report) {
        this.id = report.id;
        this.name = report.name;
        this.basePath = report.basePath;
        this.elementType = report.elementType;
        this.folder = report.folder;
        this.folderId = report.folderId;
        this.contentFavoriteId = report.contentFavoriteId;
        this.contentMetadataId = report.contentMetadataId;
        this.createdAt = report.createdAt;
        this.lastViewed = report.lastViewed;
        this.popularity = report.popularity;
        this.favoriteCount = report.favoriteCount;
        this.viewCount = report.viewCount;
        this.model = report.model;
        this.createdBy = report.createdBy;
        this.dashboards = report.dashboards;
        this.looks = report.looks;
        this.can = new canDto_1.CanDto(report.can);
        this.userId = report.userId;
    }
}
exports.ReportListItemProps = ReportListItemProps;
